export const determineUserCity = ({ nearbyDestinations = {}, countryToCityMapping = {}, defaultCity = "Prishtina" } = {}) => {
  const CACHE_LOCATION_KEY = 'userLocation';
  const CACHE_TS_KEY = 'userLocationTimestamp';
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;

  // Helper to find nearest/known city
  const findNearestCity = (cityName = '', countryName = '') => {
    const availableCities = Object.keys(nearbyDestinations);
    const lower = cityName.toLowerCase();
    if (availableCities.some((c) => c.toLowerCase() === lower)) {
      return availableCities.find((c) => c.toLowerCase() === lower);
    }
    if (countryName && countryToCityMapping[countryName]) {
      return countryToCityMapping[countryName];
    }
    return defaultCity;
  };

  // Fetch location via IP as fallback
  const fallbackToIpLocation = async () => {
    try {
      const res = await fetch('https://ipapi.co/json/');
      const data = await res.json();
      if (data.city && data.country_name) {
        return findNearestCity(data.city, data.country_name);
      }
    } catch (err) {
      console.error('IP location fetch error:', err);
    }
    return defaultCity;
  };

  // Main promise
  return new Promise((resolve) => {
    try {
      const cachedCity = localStorage.getItem(CACHE_LOCATION_KEY);
      const cachedTs = localStorage.getItem(CACHE_TS_KEY);
      if (cachedCity && cachedTs) {
        const now = Date.now();
        if (now - parseInt(cachedTs, 10) < ONE_DAY_MS) {
          resolve(cachedCity);
          return;
        }
      }
    } catch (_) {}

    // Attempt browser geolocation first
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          try {
            const resp = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`);
            const data = await resp.json();
            const city = findNearestCity(data.city, data.countryName);
            try {
              localStorage.setItem(CACHE_LOCATION_KEY, city);
              localStorage.setItem(CACHE_TS_KEY, Date.now().toString());
            } catch (_) {}
            resolve(city);
          } catch (err) {
            console.error('Reverse geocode error:', err);
            const city = await fallbackToIpLocation();
            resolve(city);
          }
        },
        async () => {
          const city = await fallbackToIpLocation();
          resolve(city);
        }
      );
    } else {
      // Fallback directly
      fallbackToIpLocation().then(resolve);
    }
  });
}; 